import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { searchArchivedContracts } from "../../../service/contract";
import { useEffect, useMemo, useRef, useState } from "react";
import { renderContractLink } from "../search/SearchContracts";
import { useTranslation } from "react-i18next";
import { getTranslationForDataGrid } from "../../../utils/Utils";
import Heading from "../../../component/heading/Heading";
import { useForm } from "react-hook-form";
import SearchInput from "../../../component/searchPage/SearchInput";
import { MainForm, SearchFormContext } from "../../../component/searchPage/SearchForm";
import SearchDropdown from "../../../component/searchPage/SearchDropdown";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const columns = (t) => [
	{
		field: "pdf_doc_name",
		headerName: t("Contract Document"),
		minWidth: 300,
		flex: 1,
		renderCell: renderContractLink,
		valueFormatter: (value) => value.pdf_doc_name,
	},
	{ field: "contract_or_schedule", headerName: t("Type"), width: 150 },
];
const criteriaData = {
	"contractType": [
		{ value: "Contract", key: "contract" },
		{ value: "Schedule", key: "schedule" },
	],
};
function ArchivedContracts() {
	const { t, i18n } = useTranslation();
	const [searchData, setSearchData] = useState({});
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 10,
	});
	const mapPageToNextCursor = useRef({});
	const handlePaginationModelChange = (newPaginationModel) => {
		// We have the cursor, we can allow the page transition.
		if (newPaginationModel.page === 0 || mapPageToNextCursor.current[newPaginationModel.page - 1]) {
			setPaginationModel(newPaginationModel);
		}
	};

	const { isFetching, data } = useQuery({
		queryKey: ["archivedContracts", paginationModel, searchData],
		queryFn: async () =>
			searchArchivedContracts(
				paginationModel,
				(() => {
					if (paginationModel.page !== 0) return mapPageToNextCursor.current[paginationModel.page - 1];
					else return undefined;
				})(),
				searchData
			),
		enabled:Boolean(searchData?.contractNo?.trim()) || Boolean(searchData?.contractType),
	});
	const paginationMetaRef = useRef(undefined);	

	// Memoize to avoid flickering when the `hasNextPage` is `undefined` during refetch
	const paginationMeta = useMemo(() => {
		if (data?.hasNextPage !== undefined && paginationMetaRef.current?.hasNextPage !== data?.hasNextPage) {
			paginationMetaRef.current = { hasNextPage: data?.hasNextPage };
		}
		return paginationMetaRef.current;
	}, [data?.hasNextPage]);

	useEffect(() => {
		if (!isFetching && data?.nextPageToken) {
			console.log("Setting the next token")
			mapPageToNextCursor.current[paginationModel.page] = data?.nextPageToken;
		}
	}, [paginationModel.page, isFetching, data?.nextPageToken]);

	return (
		<div className='container search__container'>
			<div className='search__body'>
				<MainForm criteriaData={criteriaData} requiredInputs={1} title={"Archived Contracts"} setSearchData={setSearchData}>
					<SearchInput label={"Contract Number"} dataLabel={"contractNo"} />
					<SearchDropdown label={"Contract Type"} dataLabel={"contractType"} />
				</MainForm>
				<br></br>
				<DataGrid
					disableColumnSorting
					autoHeight
					disableRowSelectionOnClick
					rows={data?.rows}
					rowCount={-1}
					columns={columns(t)}
					loading={isFetching}
					pageSizeOptions={[5, 10, 25]}
					// initialState={{ pagination: { rowCount: -1 } }}
					paginationMeta={paginationMeta}
					onPaginationModelChange={handlePaginationModelChange}
					paginationModel={paginationModel}
					paginationMode='server'
					disableColumnMenu
					localeText={getTranslationForDataGrid(i18n.resolvedLanguage)}
				/>
			</div>
		</div>
	);
}

export default ArchivedContracts;
